import { updateEditNonWorkingPeriodRequest } from "actions/updateEditNonWorkingPeriodRequest";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IUpdateNonWorkingPeriodRequestModel from "interfaces/Request/IUpdateNonWorkingPeriodRequestModel";
import { useStateMachine } from "little-state-machine";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const EditTemplate = (props: any): any => {
  const navigate = useNavigate();

  const { actions } = useStateMachine({ updateEditNonWorkingPeriodRequest });

  const {
    id,
    name,
    dateFrom,
    dateTo,
    description,
    severity,
    disposalSites,
    active,
    inUse
  } = props;

  const onEditClickHandler = () => {
    const updateNonWorkingPeriodRequest: IUpdateNonWorkingPeriodRequestModel = {
      id,
      name,
      dateFrom,
      dateTo,
      description,
      severity,
      disposalSites,
      active,
      inUse
    };

    actions.updateEditNonWorkingPeriodRequest(updateNonWorkingPeriodRequest);

    navigate(RoutePathsEnum.SettingsNonWorkingPeriodsUpdate);
  };
  return (
    <div className="d-flex justify-content-center">
      <Button
        variant="primary"
        data-testid="edit-nonworkingperiod"
        aria-label={`Edit ${name} non-working period`}
        onClick={onEditClickHandler}
      >
        Edit
      </Button>
    </div>
  );
};
export default EditTemplate;
